import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { INPUT } from "@/components/pageSettings/AdminModal";

export function useDesignOptions() {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    api.get("/admin/thankyou-designs")
      .then((r) => setOpts([...r.data.templates, ...r.data.designs.map((d) => ({ ...d, name: `${d.name} (yours)` }))]))
      .catch(() => {});
  }, []);
  return opts;
}

const CONTACT = [
  ["email", "Company email", 120, "intake@firm.com"],
  ["hours", "Hours", 120, "e.g. 7 days a week, 8am–9pm"],
  ["address", "Office address", 240, "Street, city, state"],
];

export function DesignFields({ data, form, setForm, options }) {
  const isBuyer = data.page.kind === "buyer";
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const setC = (k, v) => setForm((f) => ({ ...f, contact: { ...f.contact, [k]: v } }));
  return (
    <div className="mb-4 border-2 border-black p-3" data-testid="admin-ty-design-section">
      <label className="label-mono block">Page design
        <select className={INPUT} value={form.design || ""} onChange={(e) => set("design", e.target.value || null)} data-testid="admin-ty-design-select">
          <option value="">{isBuyer ? "Same as each funnel" : "Use the default design"}</option>
          {options.map((o) => <option key={o.key} value={o.key}>{o.name}</option>)}
        </select>
      </label>
      {isBuyer && (
        <>
          <div className="label-mono mt-3">Company details shown to the visitor</div>
          <p className="text-[10px] text-zinc-500">Company info only. No person&apos;s name or personal email.</p>
          <div className="grid gap-x-2 sm:grid-cols-2">
            {CONTACT.map(([k, label, max, ph]) => (
              <label key={k} className={`mt-1 block text-[11px] ${k === "address" ? "sm:col-span-2" : ""}`}>{label}
                <input className={INPUT} maxLength={max} placeholder={ph} value={form.contact[k] || ""}
                       onChange={(e) => setC(k, e.target.value)} data-testid={`admin-ty-contact-${k}`} />
              </label>
            ))}
          </div>
        </>
      )}
      <label className="mt-2 block text-[11px]">Short video link (YouTube, Vimeo, Wistia or .mp4 — optional)
        <input className={INPUT} maxLength={500} placeholder="https://" value={form.video_url || ""}
               onChange={(e) => set("video_url", e.target.value)} data-testid="admin-ty-video-url" />
      </label>
      <div className="mt-1 text-[10.5px] text-zinc-500">Shown on designs that include the video section.</div>
    </div>
  );
}
